import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

import { Error } from './error';

import { MemoRoutingModule } from './memo.routing.module';

declare let $: any;
const errorMessage: any = {
  required: 'Ce champ est requis'
};

@Component({
  selector: 'memo',
  template: `
  <div class="md-form form-sm" >  <!-- [formGroup]="form" -->
    <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control.value}"></i>
    <textarea id="{{name}}" name="{{name}}" class="md-textarea memocomp" [formControl]="control" [attr.length]="length" [ngClass]="{'invalid':error ,'min':min}" #memo></textarea> <!-- formControlName="{{name}}" -->
    <label for="{{name}}" [ngClass]="{'active':control.value}"><b>{{caption}}</b> <span *ngIf="required && !control.value" style="color: red;"><b>*</b></span></label> 
    <span *ngIf="error" class="help-block text-danger" [ngStyle]="{'padding-left': (glyph ? '34px' :'')}" style="font-size: 15px">
      <b>{{ error }}</b>
    </span> 
  </div>`,
  styles: [`
  textarea.md-textarea {
    overflow-y: scroll;
  }
  
  .memocomp {
      margin-bottom: 0;
  }
  
  .memo.ng-invalid {
      border-bottom: 1px solid #F44336;
      box-shadow: 0 1px 0 0 #F44336;
  }
  
  .min {
      height: 0rem!important;
      min-height: 0rem!important;
  }
  
  textarea:focus:not([readonly]) {
      border-color: #007bff !important;
      box-shadow: 0 1px 0 0 #007bff !important;
  }`]
})

export class MemoComponent implements OnInit {
  @Input() public name: string = '';
  @Input() public length: string = '0';
  @Input() public caption: string = '';
  @Input() public enabled: Boolean = false;
  @Input() public required: Boolean = false;
  @Input() public min: Boolean = false;
  @Input() public control: AbstractControl;
  @Input() public value: string = '';
  @Input() public glyph: string = ''; //fa fa-comment
  @Output() public valueChange = new EventEmitter<string>();
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public displayCharacterCounter: boolean = true;
  @ViewChild('memo') memo: ElementRef;
  public elementRef: ElementRef;
  public init: boolean = false;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit(): void {
    if (!this.init) {
      this.init = true;
      if (!this.control) {
        if (this.form.controls[this.name] == null) {
          this.control = new FormControl();
          this.form.addControl(this.name, this.control);
        }
        this.control = this.form.controls[this.name];
      }
      this.control.valueChanges
        .subscribe((data) => {
          //this.updated.emit(data);
          this.returnError();
        });
    }
  }

  ngAfterViewInit() {
    /*if (this.length != "0") {
      $('textarea#' + this.name).characterCounter();
    }*/
    if ((this.length != '0') && (this.displayCharacterCounter)) {
      $(this.memo.nativeElement).characterCounter();
    }
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          this.error += errorMessage[key] + ' ';
        }
      }
    }
  }
}
